import type { ActivityEntityName } from '@jms/model';
import type { SurfaceCapabilityParent } from '@workbuddy/ui/v2/surface.engine';
import { resolveShareOptions, type ResolvedShareOptions } from './share.options';

/** The candidate parent sharing runs under, with the toggles it offers the child. */
export interface ShareParentChoice {
  readonly parent: SurfaceCapabilityParent;
  readonly options: ResolvedShareOptions;
}

/**
 * The first candidate whose manifest declares share toggles for `child`. Candidates arrive nearest
 * first, so a task under a Stage shares through its Job until Stage declares `shareRelations` itself.
 */
export function chooseShareParent(child: ActivityEntityName, parents: readonly SurfaceCapabilityParent[]): ShareParentChoice | null {

  for (const parent of parents) {
    const options = resolveShareOptions(child, parent.entity);
    if (options) return { parent, options };
  }
  return null;
}
